module.exports = __webpack_public_path__ + "static/media/binary@3x.45fdabf0.jpg";